import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=1a8c3b18&"
import script from "./ChatView.vue?vue&type=script&lang=js&"
export * from "./ChatView.vue?vue&type=script&lang=js&"
import style0 from "./ChatView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports